var _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResizer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    height: "16px",
    width: "16px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.73,
    cy: 8,
    r: 1.31
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.73,
    cy: 1.31,
    r: 1.31
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.27,
    cy: 8,
    r: 1.31
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.27,
    cy: 1.31,
    r: 1.31
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.73,
    cy: 14.69,
    r: 1.31
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.27,
    cy: 14.69,
    r: 1.31
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResizer);
export default __webpack_public_path__ + "static/media/resizer.06899f806807536e87ebadce64282cde.svg";
export { ForwardRef as ReactComponent };